// Đợi Swiper và jQuery sẵn sàng
function initSwiper() {
	// Kiểm tra Swiper có sẵn sàng không
	if (typeof Swiper === 'undefined') {
		console.warn('Swiper chưa được load, đợi thêm...');
		setTimeout(initSwiper, 100);
		return;
	}

	// Kiểm tra jQuery có sẵn sàng không (nếu cần)
	if (typeof window.$ === 'undefined' && typeof window.jQuery === 'undefined') {
		console.warn('jQuery chưa được load, đợi thêm...');
		setTimeout(initSwiper, 100);
		return;
	}

	$(".pageContent").addClass("swiper-wrapper");

	// Khởi tạo swiper và gán global
	window.swiper = new Swiper(".wrapPage", {
		 direction: "vertical",
    slidesPerView: 1,
    effect: 'fade',
    preloadImages: false,
    mousewheel: true,
    allowTouchMove: false,
    lazy: {
      loadPrevNext: false,
      loadOnTransitionStart: false,
    },
		on: {
			init() {
				updateActiveMenu(this.activeIndex);
				updateIframeOverlayStates(this.activeIndex);
			},
			slideChange() {
				updateActiveMenu(this.activeIndex);
				updateIframeOverlayStates(this.activeIndex);
			}
		}
	});

	// Hàm cập nhật active menu
	function updateActiveMenu(activeIndex) {
		
		// Cập nhật cho navigation menu mới
		const menuItems = [
			'.list-items-home',
			'.list-items-update',
			'.list-items-daily',
			'.list-items-lucky'
		];
		
		// Xóa active từ tất cả menu items
		menuItems.forEach(selector => {
			$(`#pwm-ld-25-bigupdate-navigation ${selector}`).removeClass("active");
		});
		
		// Thêm active cho menu item tương ứng (chỉ cho 4 menu đầu)
		if (activeIndex >= 0 && activeIndex < menuItems.length) {
			$(`#pwm-ld-25-bigupdate-navigation ${menuItems[activeIndex]}`).addClass("active");
		}
	}

	// Hàm cập nhật trạng thái overlay wrapper cho các slide chứa iframe
	function updateIframeOverlayStates(activeIndex) {
		const allSlides = document.querySelectorAll('.swiper-slide');
		allSlides.forEach((slide, index) => {
			const iframe = slide.querySelector('iframe');
			if (iframe) {
				const overlayWrapper = slide.querySelector('.iframe-touch-wrapper');
				if (overlayWrapper) {
					// Chỉ enable overlay wrapper khi slide đang active
					if (index === activeIndex) {
						overlayWrapper.style.pointerEvents = 'auto';
					} else {
						overlayWrapper.style.pointerEvents = 'none';
					}
				}
			}
		});
	}
let allowScrollTrigger = true;
let touchStartY = 0;
let touchStartTime = 0;
let isSwipeGesture = false; // Flag để xác định có phải swipe không

// Hàm xử lý touch để chuyển slide
function handleTouchStart(e) {
	touchStartY = e.touches[0].clientY;
	touchStartTime = Date.now();
	isSwipeGesture = false; // Reset flag
}

function handleTouchEnd(e) {
	if (!window.swiper) return true;
	
	const touchEndY = e.changedTouches[0].clientY;
	const deltaY = touchStartY - touchEndY;
	const touchDuration = Date.now() - touchStartTime;
	const isMobile = window.innerWidth <= 768;

	// Kiểm tra xem touch có phải trên slide chứa iframe không
	const target = e.target;
	const slide = target.closest('.swiper-slide');
	const isOnIframe = target.tagName === 'IFRAME' || target.closest('iframe');
	const slideHasIframe = slide && slide.querySelector('iframe');

	// Nếu là tap/click (không đủ xa hoặc quá lâu) → không làm gì, cho phép click
	if (touchDuration > 500 || Math.abs(deltaY) < 30) {
		isSwipeGesture = false;
		return true; // Không preventDefault để cho phép click
	}

	// Trên mobile: cho phép swipe ở bất kỳ đâu để chuyển slider
	if (isMobile) {
		// Vuốt lên → slideNext
		if (deltaY > 30) {
			isSwipeGesture = true;
			window.swiper.slideNext();
			return false; // Cần preventDefault
		}
		// Vuốt xuống → slidePrev
		else if (deltaY < -30) {
			isSwipeGesture = true;
			window.swiper.slidePrev();
			return false; // Cần preventDefault
		}
	} else {
		// Trên desktop: chỉ xử lý khi ở edge của trang
		const scrollTop = window.scrollY;
		const windowHeight = window.innerHeight;
		const docHeight = document.documentElement.scrollHeight;

		// Vuốt lên → nếu gần cuối trang thì slideNext
		if (deltaY > 30 && Math.abs(docHeight - (scrollTop + windowHeight)) < 5) {
			isSwipeGesture = true;
			window.swiper.slideNext();
			return false; // Cần preventDefault
		}
		// Vuốt xuống → nếu gần đầu trang thì slidePrev
		else if (deltaY < -30 && scrollTop < 5) {
			isSwipeGesture = true;
			window.swiper.slidePrev();
			return false; // Cần preventDefault
		}
	}
	
	isSwipeGesture = false;
	return true; // Không preventDefault
}

// Thêm event listeners trên window để xử lý touch events
window.addEventListener('touchstart', handleTouchStart, { passive: true });
window.addEventListener('touchend', function(e) {
	const shouldPreventDefault = handleTouchEnd(e);
	if (shouldPreventDefault === false) {
		e.preventDefault();
		e.stopPropagation();
	}
}, { passive: false });

// Thêm event listeners trên các slide chứa iframe để bắt touch events
// Sử dụng capture phase để bắt events trước khi chúng vào iframe
document.addEventListener('touchstart', function(e) {
	// Kiểm tra xem touch có phải trên iframe không
	const target = e.target;
	if (target.tagName === 'IFRAME' || target.closest('iframe')) {
		handleTouchStart(e);
	}
}, { capture: true, passive: true });

document.addEventListener('touchend', function(e) {
	// Kiểm tra xem touch có phải trên iframe không
	const target = e.target;
	if (target.tagName === 'IFRAME' || target.closest('iframe')) {
		handleTouchEnd(e);
	}
}, { capture: true, passive: false });

// Tạo overlay transparent trên các slide chứa iframe để capture touch events
function setupIframeSlideListeners() {
	const allSlides = document.querySelectorAll('.swiper-slide');
	const isMobile = window.innerWidth <= 768;
	
	allSlides.forEach(slide => {
		// Kiểm tra xem slide có chứa iframe không
		const iframe = slide.querySelector('iframe');
		
		// Đảm bảo các slide không có iframe không có overlay wrapper
		if (!iframe) {
			// Xóa overlay wrapper nếu có (để đảm bảo không có overlay nào)
			const existingWrapper = slide.querySelector('.iframe-touch-wrapper');
			if (existingWrapper) {
				existingWrapper.remove();
			}
			return; // Skip các slide không có iframe
		}
		
		if (isMobile) {
			// Đảm bảo slide có position relative
			if (getComputedStyle(slide).position === 'static') {
				slide.style.position = 'relative';
			}
			
			// Tạo overlay ở top edge (chỉ để đánh dấu vùng, không chặn pointer events)
			let overlayTop = slide.querySelector('.iframe-touch-overlay');
			if (!overlayTop) {
				overlayTop = document.createElement('div');
				overlayTop.className = 'iframe-touch-overlay';
				slide.appendChild(overlayTop);
			}
			
			// Tạo overlay ở bottom edge
			let overlayBottom = slide.querySelector('.iframe-touch-overlay-bottom');
			if (!overlayBottom) {
				overlayBottom = document.createElement('div');
				overlayBottom.className = 'iframe-touch-overlay-bottom';
				slide.appendChild(overlayBottom);
			}
			
			// Tạo overlay wrapper với pointer-events: none mặc định
			// Chỉ enable (pointer-events: auto) khi slide đang active
			let overlayWrapper = slide.querySelector('.iframe-touch-wrapper');
			if (!overlayWrapper) {
				overlayWrapper = document.createElement('div');
				overlayWrapper.className = 'iframe-touch-wrapper';
				overlayWrapper.style.cssText = `
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					z-index: 5;
					pointer-events: none;
					touch-action: pan-y;
					background: transparent;
				`;
				slide.appendChild(overlayWrapper);
			}
			
			// Lưu reference để có thể update sau
			overlayWrapper._slideIndex = Array.from(allSlides).indexOf(slide);
			
			// Listen trên overlay wrapper để bắt tất cả touch events từ iframe
			let touchStartX = 0;
			let touchStartY = 0;
			let isPotentialSwipe = false;
			
			overlayWrapper.addEventListener('touchstart', function(e) {
				handleTouchStart(e);
				touchStartX = e.touches[0].clientX;
				touchStartY = e.touches[0].clientY;
				overlayWrapper._touchStarted = true;
			}, { passive: true });
			
			overlayWrapper.addEventListener('touchmove', function(e) {
				if (!overlayWrapper._touchStarted) return;
				
				// Track movement để xác định có phải swipe không
				const currentY = e.touches[0].clientY;
				const currentX = e.touches[0].clientX;
				const deltaY = Math.abs(touchStartY - currentY);
				const deltaX = Math.abs(touchStartX - currentX);
				
				// Nếu di chuyển đủ xa theo chiều dọc (> 10px) và ít theo chiều ngang, đánh dấu là potential swipe
				if (deltaY > 10 && deltaY > deltaX * 1.5) {
					isPotentialSwipe = true;
				}
			}, { passive: true });
			
			overlayWrapper.addEventListener('touchend', function(e) {
				if (!overlayWrapper._touchStarted) return;
				
				const wasPotentialSwipe = isPotentialSwipe;
				const touchEndX = e.changedTouches[0].clientX;
				const touchEndY = e.changedTouches[0].clientY;
				
				// Reset flags
				overlayWrapper._touchStarted = false;
				isPotentialSwipe = false;
				
				// Gọi handleTouchEnd để xử lý
				const shouldPreventDefault = handleTouchEnd(e);
				
				// Nếu không phải swipe gesture, forward click vào iframe
				if (shouldPreventDefault !== false) {
					// Không preventDefault, tạm thời disable overlay và forward click
					overlayWrapper.style.pointerEvents = 'none';
					
					// Tạo click event tại vị trí touch sau một chút delay
					setTimeout(() => {
						const clickEvent = new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window,
							clientX: touchEndX,
							clientY: touchEndY
						});
						
						// Tìm element dưới overlay tại vị trí touch
						const elementBelow = document.elementFromPoint(touchEndX, touchEndY);
						if (elementBelow && elementBelow !== overlayWrapper && elementBelow !== slide) {
							elementBelow.dispatchEvent(clickEvent);
						}
						
					// Re-enable overlay sau một chút để có thể bắt swipe tiếp theo (chỉ nếu slide vẫn active)
					setTimeout(() => {
						if (window.swiper && overlayWrapper._slideIndex === window.swiper.activeIndex) {
							overlayWrapper.style.pointerEvents = 'auto';
						}
					}, 200);
					}, 50);
				} else {
					// Nếu là swipe gesture, preventDefault để chuyển slider
					e.preventDefault();
					e.stopPropagation();
				}
			}, { passive: false });
		}
	});
}

// Setup listeners sau khi Swiper init và DOM ready
function initTouchHandlers() {
	setupIframeSlideListeners();
	// Cập nhật trạng thái overlay wrapper sau khi setup
	if (window.swiper) {
		updateIframeOverlayStates(window.swiper.activeIndex);
	}
}

// Gọi sau khi Swiper đã init
setTimeout(initTouchHandlers, 500);

}

// Khởi tạo khi DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initSwiper);
} else {
	initSwiper();
}

// ✅ Nhận message từ iframe (con)
window.addEventListener("message", function (event) {
const data = event.data;
if (! data) 
return;



// Kiểm tra Swiper có tồn tại không
if (!window.swiper || typeof window.swiper.slideTo !== "function") {
// console.warn("⚠️ Swiper chưa sẵn sàng");
return;
}

// Điều khiển slide
if (data.type === "SWIPER_GO_TO") {
const index = parseInt(data.index, 10);
if (!isNaN(index) && index >= 0 && index < window.swiper.slides.length) {
window.swiper.slideTo(index);
// console.log("🌀 GO TO slide:", index);
}
} else if (data.type === "SWIPER_NEXT") {
console.log("➡️ NEXT slide");
window.swiper.slideNext(1000);
} else if (data.type === "SWIPER_PREV") {
// console.log("⬅️ PREV slide");
window.swiper.slidePrev(1000);
}
});
